import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProgramsPage from "@/pages/ProgramsPage";
import EventsPage from "@/pages/EventsPage";
import ContactPage from "@/pages/ContactPage";
import ElevatedEscapePage from "@/pages/ElevatedEscapePage";
import ElevatedEscapeTicketsPage from "@/pages/ElevatedEscapeTicketsPage";
import NewsletterPage from "@/pages/NewsletterPage";
import CalendarPage from "@/pages/CalendarPage";
import GalleryPage from "@/pages/GalleryPage";
import OurPeoplePage from "@/pages/OurPeoplePage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import ShopPage from "@/pages/ShopPage";
import ShopConfirmationPage from "@/pages/ShopConfirmationPage";
import SchedulePage from "@/pages/SchedulePage";
import FileRoomPage from "@/pages/FileRoomPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  
  // Check for session_id in URL hash (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Admin routes without layout */}
      <Route path="/file-room" element={<FileRoomPage />} />
      <Route path="/file-room/login" element={<LoginPage />} />
      <Route path="/file-room/callback" element={<AuthCallback />} />
      
      {/* Public routes with layout */}
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/elevated-escape" element={<ElevatedEscapePage />} />
            <Route path="/elevated-escape/tickets" element={<ElevatedEscapeTicketsPage />} />
            <Route path="/elevated-escape/confirmation" element={<PaymentSuccessPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/our-people" element={<OurPeoplePage />} />
            <Route path="/newsletter" element={<NewsletterPage />} />
            <Route path="/newsletter/:postId" element={<NewsletterPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shop/confirmation" element={<ShopConfirmationPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
